export default __webpack_public_path__ + "static/media/H.9196575c.svg";